module.exports = __webpack_public_path__ + "static/media/Specialists.f9cf9768.svg";